import SmartTagAdapter from './shared/smart-tag-adapter';
import GeoLocationService from '../services/GeoLocationService';
import Domain from '../helpers/Domain';
import loadChromecast from 'bundles/module-federation/chromecast';
import { getLocalStorageMetadata } from 'video/shared/smart-tag-adapter/metadata/metadata-builder';

export default function (playerParams, initSmartTagPlugins) {
    const obj = this;

    let smartTag;

    this.streamType = null;
    this.enableCP = false;
    this.showId = null;
    this.baseUrl = null;
    this.apiMetadata = null;
    this.millstone = null;
    this.lowbandEnabled = false;
    this.playerParams = playerParams;
    this.videoAds = {};
    this.defaultLocale = '';

    this.drmTemplate = {
        enabled: false,
        sessionId: null,
        ticket: null,
        fairplay: {
            header: {
                Authorization: '',
            },
            appCertUrl: '',
            licenseUrl: '',
        },
        widevine: {
            header: {
                Authorization: '',
            },
            url: '',
        },
        playready: {},
    };

    this.paramsVO = {
        rco: {},
        setByPage: {},
        // tag application parameters
        TAG: {},
        // ad related parameters
        AD: {},
        // content related parameters
        CONTENT: {},
        CONTEXT: {},
        // skin related parameters
        SKIN: {},
        // user / page related parameters
        USER: {},
    };

    this.init = async function () {
        await loadChromecast();

        let castSender;
        if (window.Chromecast) {
            castSender = new Chromecast();
            castSender.contentId = this.playerParams._contentID;
        }

        this.drm = $.extend(this.drmTemplate, this.drm);

        if (this.drm.enabled) {
            this.paramsVO.CONTENT.drm = this.drm;
        }
        if (this.millstone) {
            this.paramsVO.CONTENT.millstone = this.millstone;
        }

        this.paramsVO.lowbandEnabled = this.lowbandEnabled;
        this.paramsVO.videoAds = this.videoAds;
        this.paramsVO.defaultLocale = this.defaultLocale;
        this.metaData = getLocalStorageMetadata(this.metaData);

        this.paramsVO = $.extend(true, this.playerParams, this.paramsVO);

        smartTag = new SmartTagAdapter(castSender, this.paramsVO, this.metaData, this.apiMetadata);
        if (initSmartTagPlugins) {
            initSmartTagPlugins(smartTag, this);
        }

        smartTag.contentId = this.playerParams._contentID;
        smartTag.enableCP = this.enableCP;
        smartTag.showId = this.showId;
        smartTag.baseUrl = this.baseUrl;
        smartTag.CPEpisodesRemainingEnabled = this.CPEpisodesRemainingEnabled;

        let startCastSender = async () => {
            let geoLocation = null;
            try {
                await smartTag.smartTagReadyPromise;
                await smartTag.pinGatePromise;
                if (Domain.isDomestic()) {
                    //INTL doesn't have geolocation check
                    geoLocation = await new GeoLocationService().fetchLocation();
                }
            } catch (e) {
                console.log(e);
            }

            if (castSender) castSender.start(smartTag.api, geoLocation);
        };

        window['__onGCastApiAvailable'] = function (isAvailable) {
            if (isAvailable) {
                startCastSender();
            }
        };

        document.addEventListener('sp.blocking', function (e) {
            smartTag.hasAdBlocker = true;
            try {
                if (typeof om != 'undefined') {
                    om.trackView({
                        adBlockStatus: 'true',
                    });
                }
            } catch (e) {}
        });
        document.addEventListener('sp.not_blocking', function (e) {
            smartTag.hasAdBlocker = false;
        });

        smartTag.onPlayerStateChanged = (playerState) => {
            if (playerState === 'PlayerState.PLAYING') {
                // signal global app User Profile video player is ready
                if (CBS.Registry.GlobalApp.UserProfile !== null) {
                    CBS.Registry.GlobalApp.UserProfile.App.videoPlayerEvent(
                        'PLAYER_STATE_CHANGE',
                        playerState,
                    );

                    const isMainOverlayOpen =
                        CBS.Registry.GlobalApp.UserProfile.App.$store.state.mainOverlay;
                    if (isMainOverlayOpen) {
                        smartTag.api.pageAction({ action: 'PageAction.PAUSE' });
                    }
                }
            }
        };

        window[this.paramsVO.jsNS] = smartTag.api;
    };
}
